/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Select_StudentInputs */

const en_lessons_select_student = /** @type {(inputs: Lessons_Select_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select student...`)
};

const he_lessons_select_student = /** @type {(inputs: Lessons_Select_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחר תלמיד...`)
};

/**
* | output |
* | --- |
* | "Select student..." |
*
* @param {Lessons_Select_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_select_student = /** @type {((inputs?: Lessons_Select_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Select_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_select_student(inputs)
	return he_lessons_select_student(inputs)
});